import React, { useEffect } from "react";
// import ServicesButtonList from "../components/ServicesButtonList";
import AOS from "aos";
import "aos/dist/aos.css";
import Schema from "./Schema";
import ServiceNavigator from "./ServiceNavigator";

const PvProtectionCoatings = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="font-sans text-gray-900 bg-gray-100">
    <Schema />
      {/* Hero Section with Black Background */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >

        <div className="w-full max-w-3xl">
          <h2 className="text-5xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            PV Protection Coatings
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-4">
            Premium Solar Panel Protection Solutions by ChemiTek
          </p>
          <p className="italic text-gray-400">
            Exclusively Distributed by SolarCare International
          </p>
        </div>
      </section>

      {/* Info Block */}
      <section
        className="px-6 py-14 max-w-4xl mx-auto text-lg leading-relaxed space-y-14"
        data-aos="fade-up"
      >
        <div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">
            Now in Sri Lanka & Maldives
          </h2>
          <p className="text-gray-700">
            As the <strong>official partner</strong> of ChemiTek in this region,
            SolarCare introduces{" "}
            <em>advanced anti-static, anti-soiling solar coatings</em> for tropical and
            coastal environments — engineered for performance and durability.
          </p>
        </div>

        <div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">Why Choose ChemiTek?</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-6 text-base text-black">
            {[
              "Reduces cleaning frequency by up to 50%",
              "Boosts energy output by preventing dust buildup",
              "Protects against bird droppings, UV, and corrosion",
              "Ideal for rooftops, utility-scale, and industrial zones",
            ].map((item, i) => (
              <li key={i} className="bg-white rounded-full px-6 py-4 text-center">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-28 px-6" data-aos="fade-up">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-yellow-400 via-pink-400 to-yellow-300 bg-clip-text text-transparent mb-14 p-4">
            Explore the Coating Range
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {[
              {
                title: "Solar Wash Protect 50 (SWP50)",
                desc: "Deep-cleaning solution with anti-adherent properties.",
              },
              {
                title: "Anti-Static Armour",
                desc: "Minimizes dust attraction and enhances conductivity.",
              },
              {
                title: "Solar Defender",
                desc: "Hydrophobic, UV-resistant coating for long-term protection.",
              },
            ].map((item, i) => (
              <div key={i} className="bg-white p-6 rounded-2xl">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Global Validation */}
      <section
        className="px-6 py-24 max-w-4xl mx-auto text-center text-lg leading-relaxed text-gray-700"
        data-aos="fade-up"
      >
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6">
          Globally Validated
        </h2>
        <p>
          Trusted by <strong>17+ leading PV brands</strong> and validated for compatibility
          and safety. Engineered in Europe by <strong>ChemiTek Portugal</strong> —
          preferred by solar engineers worldwide.
        </p>
      </section>

      {/* Video Showcase */}
      <section className="px-6 pt-10 pb-28 max-w-6xl mx-auto" data-aos="fade-up">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-12 text-center">
          PV Protection Coatings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-1 gap-10">
          {[
            "https://res.cloudinary.com/dwf8ifbzs/video/upload/v1751368043/WhatsApp_Video_2025-06-15_at_4.23.40_PM_oovgf7.mp4",
            "https://res.cloudinary.com/dwf8ifbzs/video/upload/v1751367915/WhatsApp_Video_2025-06-15_at_4.25.52_PM_1_ip7g7w.mp4",
          ].map((src, idx) => (
            <div key={idx} className="mt-0 overflow-hidden rounded-3xl shadow-lg">
              <video
                src={src}
                className="w-full h-auto object-cover"
                autoPlay
                muted
                loop
                playsInline
              >
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </section>


      {/* Application Services */}
      <section className="py-28 px-6" data-aos="fade-up">
        <div className="max-w-5xl mx-auto text-center text-lg text-gray-800">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6">
            Our Professional Services
          </h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-6 text-base text-black">
            {[
              "Certified product application teams",
              "O&M contractor training and demos",
              "Bulk purchasing for EPCs and solar farms",
              "Technical sheets, safety data & guidance",
            ].map((item, i) => (
              <li key={i} className="bg-white rounded-full px-6 py-4 text-center">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Contact Section with Flex Styling */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >

        <div className="w-full max-w-2xl">
          <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Get in Touch
          </h2>
          <p className="mb-2 font-medium">Solar Care International Pvt Ltd</p>
          <p className="mb-1">No.44/1A, Chapel Lane, Nugegoda, Sri Lanka</p>
          <p className="mb-1">+94 114 199 225 / +94 777 129 021</p>
          <p>
            <a
              href="mailto:info@solarcareinternational.com"
              className="text-blue-400 hover:text-blue-200 underline transition"
            >
              info@solarcareinternational.com
            </a>
          </p>
        </div>
        </div>
      </section>
      {/* <ServicesButtonList /> */}
      <ServiceNavigator />
    </div>
  );
};

export default PvProtectionCoatings;